
/**
 * The service that implements the functions related to autocomplete feature.
 */
export class AutocompleteService {

    public static suggestionsList: string[] | undefined = undefined;
    
    public static initSuggestions(suggestions: string[] | undefined) {
        AutocompleteService.suggestionsList = suggestions;  
    }

    public static filterSuggestions(input: string): string[] {
        const matchedSuggestions: string[] = [];
        let counter: number = 0;
        if (AutocompleteService.suggestionsList) {
            AutocompleteService.suggestionsList.forEach((suggestion: string) => {
                if (counter < 4) {
                    matchedSuggestions.push(suggestion);
                    counter++;
                } else {
                    return matchedSuggestions;
                }
            });
        }
        return matchedSuggestions;
    }
}
